function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRipeDataLogoHorizontalLightBk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "7.2697024in",
    height: "3.5565474in",
    viewBox: "0 0 184.65044 90.336304",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-15.005653,-24.441322)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g181"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect3719",
    width: 85.989586,
    height: 90.336304,
    x: 15.005653,
    y: 24.441322,
    style: {
      fill: "#f47e39",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    ry: 6.6145835
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.237247
    },
    id: "rect4526",
    width: 13.607142,
    height: 45.168156,
    x: 24.833031,
    y: 59.876595,
    ry: 0.17305341
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.212089
    },
    id: "rect4526-9",
    width: 13.607142,
    height: 36.096725,
    x: 42.53492,
    y: 68.948006,
    ry: 0.13829792
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.259528
    },
    id: "rect4526-2",
    width: 13.607142,
    height: 54.050594,
    x: 60.236801,
    y: 50.994125,
    ry: 0.20708483
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.287921
    },
    id: "rect4526-5",
    width: 13.607142,
    height: 66.523811,
    x: 77.938683,
    y: 38.520905,
    ry: 0.25487363
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: "39.7073px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#b6b7b8",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.823177
    },
    x: 132.09814,
    y: 88.580696,
    id: "text4565",
    transform: "scale(0.78817629,1.2687517)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 132.09814,
    y: 88.580696,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: "39.7073px",
      fontFamily: "sans-serif",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#9a9a9a",
      fillOpacity: 1,
      strokeWidth: 0.823177
    }
  }, "DATA")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "50.8px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#f47e39",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.264583
    },
    x: 102.69614,
    y: 61.671989,
    id: "text4569"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 102.69614,
    y: 61.671989,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "50.8px",
      fontFamily: "sans-serif",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#f47e39",
      fillOpacity: 1,
      strokeWidth: 0.264583
    }
  }, "ripe")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRipeDataLogoHorizontalLightBk);
export default __webpack_public_path__ + "static/media/RipeDataLogoHorizontalLightBk.518bf5b7cee077661abbee4e3933c635.svg";
export { ForwardRef as ReactComponent };